/* ==================================================================== */
/* UNDENIABLE — Laufzeit der Produktseite (v20)                          */
/* ------------------------------------------------------------------ */
/* Ein Scroll-Loop (rAF) treibt alles, was am Scrollen haengt:          */
/*   Buehne      3D-Flakon-Anflug (undeniable-bottle3d.js), Video-Zoom  */
/*   Noten       horizontale Tafeln, gepinnt                            */
/*   Studien     Zahlen-Wechsel, gepinnt                                */
/*   Fuer sie    Zitat Wort fuer Wort, Profilbalken                     */
/* Dazu: Zitat-Karussell, Sticky-Leiste, Videos nur im Bild abspielen.  */
/* Alles idempotent (Theme-Editor).                                     */
/* ==================================================================== */

(function () {
  'use strict';

  var root = document.documentElement;
  root.classList.add('und-js');

  var reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var desktop = function () { return window.innerWidth >= 1000; };
  var clamp = function (v, a, b) { return Math.max(a, Math.min(b, v)); };

  /* ---------- Scroll-Loop ---------- */

  var tasks = [];
  var frame = 0;

  function tick() {
    frame = 0;
    for (var i = 0; i < tasks.length; i++) tasks[i]();
  }

  function request() { if (!frame) frame = requestAnimationFrame(tick); }
  window.addEventListener('scroll', request, { passive: true });
  window.addEventListener('resize', request);

  /* Fortschritt einer gepinnten Szene: 0 = Pin beginnt, 1 = Pin endet */
  function pinProgress(el, pinH) {
    var r = el.getBoundingClientRect();
    var total = r.height - pinH;
    if (total <= 0) return 0;
    return clamp(-r.top / total, 0, 1);
  }

  /* ---------- Reveal ---------- */

  var revealIO = null;

  function setupReveal(scope) {
    var nodes = scope.querySelectorAll('[data-und-reveal]:not(.is-in)');
    if (!nodes.length) return;
    if (reduced || !('IntersectionObserver' in window)) {
      nodes.forEach(function (n) { n.classList.add('is-in'); });
      return;
    }
    if (!revealIO) {
      revealIO = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          if (!e.isIntersecting) return;
          e.target.classList.add('is-in');
          revealIO.unobserve(e.target);
        });
      }, { rootMargin: '0px 0px -8% 0px', threshold: 0.1 });
    }
    nodes.forEach(function (n) { revealIO.observe(n); });
  }

  /* ---------- Videos nur im Bild abspielen ---------- */

  var videoIO = null;

  function setupVideos(scope) {
    var vids = scope.querySelectorAll('.und video:not([data-und-v])');
    if (!vids.length) return;
    vids.forEach(function (v) {
      v.dataset.undV = '1';
      v.muted = true;
      v.setAttribute('playsinline', '');
      if (reduced) { v.removeAttribute('autoplay'); v.pause(); }
    });
    if (reduced || !('IntersectionObserver' in window)) return;
    if (!videoIO) {
      videoIO = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          var v = e.target;
          if (v.hasAttribute('data-und-intro') || v.dataset.undHold) return;
          if (e.isIntersecting) {
            var p = v.play();
            if (p && p.catch) p.catch(function () {});
          } else {
            v.pause();
          }
        });
        /* nur abspielen, was wirklich im Bild ist: mehrere gleichzeitig dekodierte Videos bremsen Handys aus */
      }, { rootMargin: '0px', threshold: 0.02 });
    }
    vids.forEach(function (v) { videoIO.observe(v); });
  }

  /* ---------- 01 Buehne ---------- */

  function webgl() {
    try {
      var c = document.createElement('canvas');
      return !!(window.WebGLRenderingContext && (c.getContext('webgl2') || c.getContext('webgl')));
    } catch (e) { return false; }
  }

  /* ---------- 01 Buehne: realistischer Anflug als Bildsequenz ---------- */

  /* Sprite-Sheets <praefix>0.webp, 1.webp … mit je "per" Bildern in "cols" Spalten.
     Bild i liegt auf Sheet floor(i / per). Gibt setProgress(p) zurueck. */
  function setupSeq(stage, canvas) {
    var first = stage.getAttribute('data-und-seq');
    var n = parseInt(stage.getAttribute('data-und-seq-n'), 10) || 0;
    var per = parseInt(stage.getAttribute('data-und-seq-per'), 10) || 24;
    var cols = parseInt(stage.getAttribute('data-und-seq-cols'), 10) || 6;
    var fw = parseInt(stage.getAttribute('data-und-seq-fw'), 10) || 640;
    var fh = parseInt(stage.getAttribute('data-und-seq-fh'), 10) || 360;
    if (!first || n < 2 || !canvas) return null;
    var ctx = canvas.getContext('2d');
    canvas.width = fw; canvas.height = fh;
    var sheets = Math.ceil(n / per), imgs = [], ok = [], cur = -1, want = 0;
    var src = function (k) { return first.replace(/0\.webp/, k + '.webp'); };
    function draw() {
      var i = want, k = Math.floor(i / per);
      while (k >= 0 && !ok[k]) { k--; i = k * per + per - 1; }   /* naechstes geladenes Bild davor */
      if (k < 0 || i === cur) return;
      var j = i % per;
      ctx.clearRect(0, 0, fw, fh);
      ctx.drawImage(imgs[k], (j % cols) * fw, Math.floor(j / cols) * fh, fw, fh, 0, 0, fw, fh);
      cur = i;
    }
    (function load(k) {
      if (k >= sheets) return;
      var im = new Image();
      im.decoding = 'async';
      im.onload = function () { ok[k] = true; if (k === 0) stage.classList.add('is-3d'); draw(); load(k + 1); };
      im.onerror = function () { load(k + 1); };
      imgs[k] = im;
      im.src = src(k);
    })(0);
    return {
      setProgress: function (p, lite) {
        /* Bilder ueber den ganzen Anflug; am Ende bleibt das Nahbild stehen,
           die naechste Sektion schiebt sich darueber */
        want = Math.round(clamp(p, 0, 1) * (n - 1));
        draw();
      }
    };
  }

  /* Atlas-Variante: jedes Bild ist auf den Flakon zugeschnitten und in
     Bildkarten gepackt. Manifest:
       { w, h, s, ref:[x,y,w,h], sheets, ext, fixed, frames:[[sheet,sx,sy,sw,sh,dx,dy],...], core:[[x0,y0,x1,y1],...] }
     dx/dy, ref und core liegen im Leinwandraum w x h (quadratisch, mit Rand um den Flakon);
     Karten koennen verkleinert sein (s): Zielgroesse = Quelle / s.
     ref  = Ausschnitt, dessen Hoehe am Desktop die Buehne fuellt; pan = Versatz nach unten am Ende.
     core = deckender Flakon ohne Lichtschein; daran richtet sich der Handy-Ausschnitt aus,
            damit der Flakon nie abgeschnitten wird.
     fixed = ganze Szenenbilder mit eigener Kamerafahrt (Noir): fester Ausschnitt statt Mitfuehren. */
  function setupAtlas(stage, canvas) {
    /* Handys bekommen ein leichtes Atlas: die grossen 4096er-Karten sprengen dort den Grafikspeicher */
    var small = !desktop();
    var url = (small && stage.getAttribute('data-und-atlas-m')) || stage.getAttribute('data-und-atlas');
    if (!url || !canvas || !window.fetch) return null;
    var ctx = canvas.getContext('2d');
    var man = null, imgs = [], loaded = [], bmp = [], busy = [], want = 0, cur = -1, track = null, mode = '';

    /* Mitte und Ausdehnung des Flakons je Bild, ueber Nachbarbilder geglaettet */
    function tracks(m) {
      var n = m.frames.length, raw = [], out = [];
      for (var i = 0; i < n; i++) {
        var c = m.core && m.core[i], f = m.frames[i], k = f[7] || m.s || 1;
        if (!c) c = [f[5], f[6], f[5] + f[3] / k, f[6] + f[4] / k];
        var w = c[2] - c[0], h = c[3] - c[1];
        raw.push([(c[0] + c[2]) / 2, (c[1] + c[3]) / 2, Math.sqrt(w * w + h * h)]);
      }
      var span = Math.max(2, Math.round(n / 16));
      for (var a = 0; a < n; a++) {
        var sx = 0, sy = 0, sd = 0, cnt = 0;
        for (var b = Math.max(0, a - span); b <= Math.min(n - 1, a + span); b++) { sx += raw[b][0]; sy += raw[b][1]; sd += raw[b][2]; cnt++; }
        out.push([sx / cnt, sy / cnt, sd / cnt]);
      }
      return out;
    }

    function fit() {
      if (!man) return;
      var m = desktop() ? 'full' : 'crop';
      /* Zeichenflaeche = Buehne; Pixeldichte gedeckelt, mehr steckt in den Bildkarten nicht */
      var dpr = Math.min(window.devicePixelRatio || 1, m === 'crop' ? 2 : 1.5);
      var cap = 1300 / Math.max(canvas.clientHeight, 1);
      dpr = Math.min(dpr, Math.max(cap, 0.75));
      var w = Math.round(canvas.clientWidth * dpr), h = Math.round(canvas.clientHeight * dpr);
      if (w && h && (canvas.width !== w || canvas.height !== h)) { canvas.width = w; canvas.height = h; cur = -1; }
      if (m !== mode) { mode = m; cur = -1; }
    }

    /* Vorrat: nur die Karten rund ums aktuelle Bild liegen fertig dekodiert im Speicher.
       So steht das Bild nicht, wenn eine neue Karte gebraucht wird, und der Speicher bleibt klein. */
    var AHEAD = small ? 4 : 6, BEHIND = small ? 1 : 2, dir = 1, lastWant = 0;
    function need(k) {
      if (!loaded[k] || bmp[k] || busy[k]) return;
      if (!window.createImageBitmap) { bmp[k] = imgs[k]; return; }
      busy[k] = true;
      createImageBitmap(imgs[k]).then(function (b) {
        busy[k] = false;
        if (!inWin(k, man.frames[want][0])) { if (b.close) b.close(); return; }
        bmp[k] = b;
        cur = -1;
        draw();
      }, function () { busy[k] = false; bmp[k] = imgs[k]; cur = -1; draw(); });
    }
    /* in Scrollrichtung weiter vorausdekodieren als zurueck */
    function inWin(q, k) {
      var d = (q - k) * dir;
      return d >= -BEHIND && d <= AHEAD;
    }
    function stock(k) {
      /* zuerst die naechsten Karten in Scrollrichtung anstossen, dann den Rest */
      for (var o = 0; o <= AHEAD; o++) { var nq = k + o * dir; if (nq >= 0 && nq < man.sheets) need(nq); }
      for (var q = 0; q < man.sheets; q++) {
        if (inWin(q, k)) need(q);
        else if (bmp[q]) { if (bmp[q] !== imgs[q] && bmp[q].close) bmp[q].close(); bmp[q] = null; }
      }
    }

    function draw() {
      if (!man || !canvas.width) return;
      var n = man.frames.length, i = want, f = man.frames[i];
      stock(f[0]);
      /* noch nicht dekodiert: naechstes fertige Bild davor, sonst danach (wird gleich ersetzt) */
      while (i > 0 && !bmp[f[0]]) { i--; f = man.frames[i]; }
      if (!bmp[f[0]]) { i = want; f = man.frames[i]; while (i < n - 1 && !bmp[f[0]]) { i++; f = man.frames[i]; } }
      if (!bmp[f[0]] || i === cur) return;
      var k = f[7] || man.s || 1, cw = canvas.width, ch = canvas.height, s, x0, y0;
      if (man.fixed) {
        /* Szene mit Kamerafahrt (fixed): ganze Bilder, kein Mitfuehren am Flakon.
           Desktop: Bildhoehe = Buehnenhoehe, mittig. Handy: mindestens volle Breite, sonst 62 % der Hoehe,
           mittig; die Raender laufen per CSS-Maske in den Seitengrund aus. */
        s = mode === 'crop' ? Math.max(cw / man.w, ch * 0.62 / man.h) : ch / man.h;
        x0 = man.w / 2 - cw / 2 / s;
        y0 = man.h / 2 - ch * (mode === 'crop' ? 0.46 : 0.5) / s;
      } else if (mode === 'crop') {
        /* Handy: die Buehne ist der ganze Bildschirm. Der Flakon startet klein unterhalb des Textes
           und waechst bis zur Endpose auf volle Bildschirmbreite (Hoehe nie ueber 92 %).
           Groesse ueber die Diagonale, die bleibt bei jeder Drehlage gleich. */
        var t = i / (n - 1), tr = track[i], t0r = track[0], tE = track[n - 1];
        var e = t < 0.5 ? 2 * t * t : 1 - Math.pow(-2 * t + 2, 2) / 2;
        var cE = man.core[n - 1], wE = cE[2] - cE[0], hE = cE[3] - cE[1];
        var dStart = ch * 0.3, dEnd = tE[2] * Math.min(cw / wE, ch * 0.86 / hE);
        s = dStart * Math.pow(dEnd / dStart, e) / tr[2];
        var yc = ch * (0.6 - 0.065 * e);          /* Endpose etwas unter der Mitte: Kappe bleibt unter der Kopfzeile frei */
        x0 = tr[0] - cw / 2 / s;
        y0 = tr[1] - yc / s;
      } else {
        /* Desktop: der Referenz-Ausschnitt fuellt die Buehnenhoehe, mittig */
        var r = man.ref || [0, 0, man.w, man.h];
        /* gegen Ende wandert der Ausschnitt nach unten aufs Etikett (pan), damit es ganz im Bild steht */
        var td = i / (n - 1), pe = clamp((td - 0.55) / 0.45, 0, 1);
        pe = pe * pe * (3 - 2 * pe);
        s = ch / r[3];
        x0 = r[0] + r[2] / 2 - cw / 2 / s;
        y0 = r[1] + (man.pan || 0) * pe;
      }
      ctx.clearRect(0, 0, cw, ch);
      ctx.drawImage(bmp[f[0]], f[1], f[2], f[3], f[4], (f[5] - x0) * s, (f[6] - y0) * s, f[3] / k * s, f[4] / k * s);
      cur = i;
    }

    window.addEventListener('resize', function () { fit(); draw(); });
    fetch(url).then(function (r) { return r.json(); }).then(function (m) {
      man = m;
      if (m.fixed) stage.classList.add('is-scene');
      track = tracks(m);
      fit();
      var ext = m.ext || 'webp', next = 0, active = 0;
      /* Karten der Reihe nach laden, vier gleichzeitig */
      function pump() {
        while (active < 4 && next < m.sheets) start(next++);
      }
      function start(k) {
        active++;
        var im = new Image();
        im.decoding = 'async';
        im.onload = function () {
          imgs[k] = im;
          loaded[k] = true;
          active--;
          if (k === 0) stage.classList.add('is-3d');
          cur = -1;
          fit(); draw(); pump();
        };
        im.onerror = function () { active--; pump(); };
        im.src = url.replace(/atlas\.json/, 'atlas-' + k + '.' + ext);
      }
      pump();
    }).catch(function () {});
    return {
      setProgress: function (p) {
        if (!man) return;
        want = Math.round(clamp(p, 0, 1) * (man.frames.length - 1));
        if (want !== lastWant) { dir = want > lastWant ? 1 : -1; lastWant = want; }
        draw();
      }
    };
  }

  /* Intro (einmal) → Loop: das Intro endet im ersten Bild des Loops */
  function setupIntro(media) {
    var intro = media && media.querySelector('[data-und-intro]');
    var loop = media && media.querySelector('.und-hero__loop');
    if (!intro || !loop) return;
    loop.dataset.undHold = '1';
    var start = function () {
      if (!loop.dataset.undHold) return;
      delete loop.dataset.undHold;
      loop.currentTime = 0;
      var p = loop.play();
      if (p && p.catch) p.catch(function () {});
      intro.classList.add('is-done');
    };
    if (reduced) { intro.classList.add('is-done'); intro.pause(); return; }
    intro.addEventListener('ended', start);
    intro.addEventListener('error', start);
    /* Sicherheitsnetz, falls das Intro nicht startet (Energiesparmodus, Autoplay-Sperre) */
    setTimeout(function () { if (intro.readyState < 2 && intro.currentTime === 0) start(); }, 6000);
  }

  function setupHero(hero) {
    if (hero.dataset.undReady) return;
    hero.dataset.undReady = '1';

    var media = hero.querySelector('.und-hero__media');
    var stage = hero.querySelector('.und-stage');
    var pin = hero.querySelector('.und-hero__pin');
    var bar = hero.querySelector('.und-sticky');
    var buy = hero.querySelector('.und-hero__buy');
    var pinned = hero.classList.contains('und-hero--pin');
    var bottle = null;
    var lastOut = -1;
    var lastP = -1;
    var space = hero.querySelector('.und-hero__space');
    var wasGone = null;

    setupIntro(media);
    var seq = null;
    if (stage && !reduced) {
      if (stage.hasAttribute('data-und-atlas')) seq = setupAtlas(stage, stage.querySelector('canvas'));
      else if (stage.hasAttribute('data-und-seq')) seq = setupSeq(stage, stage.querySelector('canvas'));
    }

    /* 3D-Flakon nachladen (Modul), Standbild bleibt bis dahin stehen */
    var mod = stage && stage.getAttribute('data-und-3d');
    var canvas = stage && stage.querySelector('canvas');
    if (mod && canvas && !reduced && webgl()) {
      /* Als <script type="module"> laden: Shopify minifiziert Theme-JS und
         wuerde ein dynamisches import() in require() umschreiben */
      var mount = function () {
        var api = window.UndeniableBottle3D;
        if (!api || bottle) return;
        bottle = api.mountBottle(canvas, {
          label: stage.getAttribute('data-und-label'),
          choreo: stage.getAttribute('data-und-choreo') || 'spiral',
          lite: function () { return !desktop() || !pinned; },
          onReady: function () { stage.classList.add('is-3d'); request(); }
        });
        request();
      };
      if (window.UndeniableBottle3D) mount();
      else {
        window.addEventListener('und:3d', mount, { once: true });
        if (!document.querySelector('script[data-und-3d]')) {
          var s = document.createElement('script');
          s.type = 'module';
          s.src = mod;
          s.setAttribute('data-und-3d', '');
          document.head.appendChild(s);
        }
      }
    }

    tasks.push(function () {
      var p;
      if (pinned && desktop()) {
        /* die letzten 100vh gehoeren dem Ueberschieben der Folgesektion. Der Anflug laeuft noch
           in die erste knappe Haelfte davon hinein: die Folgesektion kommt schon hoch, waehrend
           der Flakon die letzten Bilder fliegt, eine Bewegung geht in die naechste ueber */
        var hr = hero.getBoundingClientRect();
        var run = hr.height - pin.offsetHeight - window.innerHeight;
        p = run > 0 ? clamp(-hr.top / (run + window.innerHeight * 0.45), 0, 1) : 0;
      } else if (pinned && buy) {
        /* Handy: der Flakon steht fest im Bild. Der Anflug beginnt mit dem ersten Scrollen (der Text
           scrollt weg) und ist fertig, wenn die Kaufkarte von unten bis gut ins Bild gekommen ist */
        var vh = window.innerHeight, hr2 = hero.getBoundingClientRect(), br = buy.getBoundingClientRect();
        var since = -hr2.top, dist = (br.top - hr2.top) - vh * 0.38;
        p = dist > 0 ? clamp(since / dist, 0, 1) : 0;
        var gone = hero.getBoundingClientRect().bottom < 0;
        if (gone !== wasGone) {
          wasGone = gone;
          hero.classList.toggle('is-gone', gone);
          /* das Video liegt fest im Bild, der Sichtbarkeits-Beobachter merkt nicht, dass es verdeckt ist */
          var lv = media && media.querySelector('.und-hero__loop');
          if (lv && !reduced) { if (gone) lv.pause(); else { var pp = lv.play(); if (pp && pp.catch) pp.catch(function () {}); } }
        }
      } else {
        /* ohne Pin: 0 ganz oben, 1 sobald die Buehne zu 70 % aus dem Bild ist */
        var r = (stage || hero).getBoundingClientRect();
        var end = r.top + window.scrollY + r.height * 0.7;
        p = clamp(window.scrollY / Math.max(end, 1), 0, 1);
      }
      if (bottle) bottle.setProgress(p);
      if (Math.abs(p - lastP) > 0.002) { lastP = p; hero.style.setProperty('--und-p', p.toFixed(3)); }
      if (seq) seq.setProgress(p, !(pinned && desktop()));
      /* Video-Zoom nur am Desktop: mobil kostet das Skalieren des Videos bei jedem Scrollschritt zu viel */
      if (media && !reduced && desktop()) media.style.setProperty('--und-zoom', (1.06 - p * 0.06).toFixed(3));
      var flying = pinned && desktop();
      /* Text und Kaufkarte bleiben stehen, bis der Flakon gross wird; dann schiebt er sie
         scrollgesteuert seitlich aus dem Bild (--und-out 0..1) */
      var out = flying ? clamp((p - 0.34) / 0.3, 0, 1) : 0;
      out = out * out * (3 - 2 * out);
      if (out !== lastOut) {
        lastOut = out;
        hero.style.setProperty('--und-out', out.toFixed(4));
      }
      hero.classList.toggle('is-turned', p > 0.03);
      hero.classList.toggle('is-flying', flying && out > 0.5);
      if (bar && flying) bar.classList.toggle('is-on', p > 0.5);
    });

    /* Handy: Hinweis-Leiste mit Preis, bis die Kaufkarte von unten ins Bild kommt; Tippen scrollt hin */
    var peek = hero.querySelector('[data-und-peek]');
    if (peek && buy) {
      var peekOn = null;
      tasks.push(function () {
        var on = !desktop() && buy.getBoundingClientRect().top > window.innerHeight * 0.92;
        if (on !== peekOn) { peekOn = on; peek.classList.toggle('is-on', on); }
      });
      /* Eigene, langsame Scroll-Fahrt: der Flakon dreht sich dabei sichtbar mit.
         Jede Beruehrung, Mausrad oder Taste bricht sie sofort ab. */
      var glide = 0;
      var stopGlide = function () { if (glide) { cancelAnimationFrame(glide); glide = 0; } };
      ['touchstart', 'wheel', 'keydown', 'mousedown'].forEach(function (ev) { window.addEventListener(ev, stopGlide, { passive: true }); });
      peek.addEventListener('click', function (e) {
        e.preventDefault();
        stopGlide();
        var from = window.scrollY;
        var to = from + buy.getBoundingClientRect().top - (parseFloat(getComputedStyle(document.documentElement).getPropertyValue('--header-height')) || 64) - 12;
        if (reduced) { window.scrollTo({ top: to, behavior: 'instant' }); return; }
        var dur = clamp(Math.abs(to - from) * 2.3, 1800, 3600), t0 = 0;
        var step = function (t) {
          if (!t0) t0 = t;
          var k = clamp((t - t0) / dur, 0, 1);
          var e2 = 0.5 - Math.cos(Math.PI * k) / 2;            /* sanft an- und auslaufen */
          window.scrollTo({ top: from + (to - from) * e2, behavior: 'instant' });
          glide = k < 1 ? requestAnimationFrame(step) : 0;
        };
        glide = requestAnimationFrame(step);
      });
    }

    /* Ohne Anflug (mobil / ohne Pin): Leiste, sobald der Kaufbereich oben raus ist */
    if (bar && buy && 'IntersectionObserver' in window) {
      new IntersectionObserver(function (entries) {
        if (pinned && desktop()) return;
        var e = entries[0];
        bar.classList.toggle('is-on', !e.isIntersecting && e.boundingClientRect.bottom < 0);
      }, { threshold: 0 }).observe(buy);
    }
  }

  /* ---------- Schriftzug-Band: Kontur fuellt sich beim Scrollen ---------- */

  function setupBand(band) {
    if (band.dataset.undReady) return;
    band.dataset.undReady = '1';
    var last = -1;
    tasks.push(function () {
      var r = band.getBoundingClientRect(), vh = window.innerHeight;
      if (r.bottom < 0 || r.top > vh) return;
      var p = reduced ? 1 : clamp((vh * 0.9 - r.top) / (vh * 0.75), 0, 1);
      if (Math.abs(p - last) > 0.003) { last = p; band.style.setProperty('--und-fill', p.toFixed(3)); }
    });
  }

  /* ---------- Noir: Winterabend (Bilder blenden beim Scrollen ueber) ---------- */

  function setupScene(sc) {
    if (sc.dataset.undReady) return;
    sc.dataset.undReady = '1';
    var slides = sc.querySelectorAll('.noir-scene__slide');
    var dots = sc.querySelectorAll('.noir-scene__dots i');
    var n = slides.length, current = -1;
    if (!n) return;
    tasks.push(function () {
      var r = sc.getBoundingClientRect(), vh = window.innerHeight;
      if (r.bottom < 0 || r.top > vh) return;
      var total = r.height - vh;
      var p = total > 0 ? clamp(-r.top / total, 0, 0.9999) : 0;
      var idx = Math.floor(p * n);
      if (idx !== current) {
        current = idx;
        slides.forEach(function (s, k) { s.classList.toggle('is-on', k === idx); });
        dots.forEach(function (d, k) { d.classList.toggle('is-on', k === idx); });
      }
      if (!reduced) slides[idx].style.setProperty('--sp', (p * n - idx).toFixed(3));
    });
  }

  /* ---------- Noir: Duftkompass (Netzdiagramm aus den Listenwerten) ---------- */

  function setupCompass(fig) {
    if (fig.dataset.undReady) return;
    fig.dataset.undReady = '1';
    var svg = fig.querySelector('svg');
    var items = [].slice.call(fig.querySelectorAll('.noir-compass__data li'));
    var n = items.length;
    if (!svg || n < 3) return;
    var NS = 'http://www.w3.org/2000/svg', R = 110;
    var pt = function (i, v) {
      var a = -Math.PI / 2 + i * 2 * Math.PI / n;
      return [Math.cos(a) * R * v / 100, Math.sin(a) * R * v / 100];
    };
    var el = function (tag, attrs) { var e = document.createElementNS(NS, tag); for (var k in attrs) e.setAttribute(k, attrs[k]); svg.appendChild(e); return e; };
    [25, 50, 75, 100].forEach(function (v) {
      el('polygon', { 'class': 'noir-compass__ring', points: items.map(function (_, i) { return pt(i, v).join(','); }).join(' ') });
    });
    items.forEach(function (li, i) {
      var e = pt(i, 100);
      el('line', { 'class': 'noir-compass__axis', x1: 0, y1: 0, x2: e[0], y2: e[1] });
      var l = pt(i, 124);
      var t = el('text', { 'class': 'noir-compass__label', x: l[0].toFixed(1), y: (l[1] + 4).toFixed(1), 'text-anchor': Math.abs(l[0]) < 8 ? 'middle' : (l[0] > 0 ? 'start' : 'end') });
      t.textContent = li.getAttribute('data-label');
    });
    var poly = function (key, cls) {
      return el('polygon', { 'class': cls, points: items.map(function (li, i) { return pt(i, parseFloat(li.getAttribute(key)) || 0).join(','); }).join(' ') });
    };
    poly('data-b', 'noir-compass__orig');
    poly('data-a', 'noir-compass__noir');
  }

  /* ---------- 03 Noten ---------- */

  function setupComp(comp) {
    if (comp.dataset.undReady) return;
    comp.dataset.undReady = '1';
    var pin = comp.querySelector('.und-comp__pin');
    var track = comp.querySelector('.und-comp__track');
    var panels = comp.querySelectorAll('.und-panel');
    var dots = comp.querySelectorAll('.und-comp__progress i');
    if (!pin || !track || !panels.length) return;

    var current = -1;
    var setActive = function (i) {
      if (i === current) return;
      current = i;
      dots.forEach(function (d, k) { d.classList.toggle('is-on', k === i); });
    };
    setActive(0);

    tasks.push(function () {
      if (!desktop()) { track.style.transform = ''; return; }
      var p = pinProgress(comp, pin.getBoundingClientRect().height);
      var max = track.scrollWidth - window.innerWidth;
      track.style.transform = 'translate3d(' + (-p * max).toFixed(1) + 'px,0,0)';
      setActive(Math.round(p * (panels.length - 1)));
    });

    /* Mobil: nativer Wischer */
    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (entries) {
        if (desktop()) return;
        entries.forEach(function (e) {
          if (e.isIntersecting && e.intersectionRatio > 0.6) setActive([].indexOf.call(panels, e.target));
        });
      }, { root: track, threshold: [0.6] });
      panels.forEach(function (p) { io.observe(p); });
    }
  }

  /* ---------- 04 Studien ---------- */

  function setupSignal(sig) {
    if (sig.dataset.undReady) return;
    sig.dataset.undReady = '1';
    var pin = sig.querySelector('.und-signal__pin');
    var slides = sig.querySelectorAll('.und-slide');
    var dots = sig.querySelectorAll('.und-signal__dots i');
    if (!pin || !slides.length) return;
    var current = -1;
    tasks.push(function () {
      var p = pinProgress(sig, pin.getBoundingClientRect().height);
      var idx = clamp(Math.floor(p * slides.length), 0, slides.length - 1);
      if (idx === current) return;
      current = idx;
      slides.forEach(function (s, k) { s.classList.toggle('is-on', k === idx); });
      dots.forEach(function (d, k) { d.classList.toggle('is-on', k <= idx); });
    });
  }

  /* ---------- 05 Fuer sie ---------- */

  function setupHer(her) {
    if (her.dataset.undReady) return;
    her.dataset.undReady = '1';

    var quote = her.querySelector('.und-her__quote');
    if (!quote || reduced) return;
    if (!quote.dataset.undSplit) {
      quote.dataset.undSplit = '1';
      var words = quote.textContent.trim().split(/\s+/);
      quote.textContent = '';
      words.forEach(function (w, i) {
        var s = document.createElement('span');
        s.className = 'und-w';
        s.textContent = w;
        quote.appendChild(s);
        if (i < words.length - 1) quote.appendChild(document.createTextNode(' '));
      });
    }
    var spans = quote.querySelectorAll('.und-w');
    tasks.push(function () {
      var r = quote.getBoundingClientRect();
      var vh = window.innerHeight;
      var p = clamp((vh * 0.88 - r.top) / (vh * 0.45), 0, 1);
      var n = Math.round(p * spans.length);
      spans.forEach(function (w, i) { w.classList.toggle('is-on', i < n); });
    });
  }

  /* ---------- 06 Stimmen ---------- */

  function setupVoices(v) {
    if (v.dataset.undReady) return;
    v.dataset.undReady = '1';
    var items = v.querySelectorAll('.und-voice');
    var nav = v.querySelectorAll('.und-voices__nav button');
    if (items.length < 2) return;
    var i = 0, timer = 0, dur = 7000, paused = false;

    var show = function (k) {
      i = (k + items.length) % items.length;
      items.forEach(function (it, n) { it.classList.toggle('is-on', n === i); });
      nav.forEach(function (b, n) {
        b.classList.toggle('is-on', n === i);
        b.classList.toggle('is-done', n < i);
        b.setAttribute('aria-current', n === i ? 'true' : 'false');
        if (n === i) { var bar = b.querySelector('i'); bar.style.animation = 'none'; void bar.offsetWidth; bar.style.animation = ''; }
      });
    };
    var schedule = function () {
      clearTimeout(timer);
      if (reduced) return;
      timer = setTimeout(function () { if (!paused) show(i + 1); schedule(); }, dur);
    };
    v.style.setProperty('--und-dur', dur + 'ms');
    nav.forEach(function (b, n) { b.addEventListener('click', function () { show(n); schedule(); }); });
    v.addEventListener('pointerenter', function () { paused = true; });
    v.addEventListener('pointerleave', function () { paused = false; });
    show(0);
    schedule();
  }

  /* ---------- Finale → Produktformular ---------- */

  function setupSubmitters(scope) {
    scope.querySelectorAll('[data-und-submit]:not([data-und-ready])').forEach(function (btn) {
      btn.dataset.undReady = '1';
      btn.addEventListener('click', function (e) {
        var form = document.querySelector('.und-hero form[is="product-form"]') || document.querySelector('form[is="product-form"]');
        if (!form) return;
        e.preventDefault();
        if (typeof form.requestSubmit === 'function') form.requestSubmit(); else form.submit();
      });
    });
  }

  /* ---------- Init ---------- */

  function init(scope) {
    scope = scope || document;
    setupReveal(scope);
    setupVideos(scope);
    setupSubmitters(scope);
    scope.querySelectorAll('.und-hero').forEach(setupHero);
    scope.querySelectorAll('.und-comp').forEach(setupComp);
    scope.querySelectorAll('[data-und-band]').forEach(setupBand);
    scope.querySelectorAll('[data-noir-scene]').forEach(setupScene);
    scope.querySelectorAll('[data-noir-compass]').forEach(setupCompass);
    scope.querySelectorAll('.und-signal').forEach(setupSignal);
    scope.querySelectorAll('.und-her').forEach(setupHer);
    scope.querySelectorAll('.und-voices').forEach(setupVoices);
    request();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(); });
  else init();

  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
  window.UndeniablePDP = { init: init };
})();
